import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import api from "../../../components/services/api";
import { green } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";
import { Autocomplete } from "@mui/material";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    height: "80%",
  },
}));

export default function DialogAddFac(props) {
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [FactoryList, setFactoryList] = useState([]);
  const [FacListForTable, setFacListForTable] = useState([]);

  const getFactoryList = async () => {
    try {
      const result = await api.get("api/factory/list");
      const _result = result.data.filter(e => e.Status === true).map((x) => ({ ...x, selected: false }));
      // props.FacReturnSelectedList(_result);
      setFactoryList(_result);
      setFacListForTable(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    getFactoryList();
  }, []);

  useEffect(() => {
    setFacListForTable(FacListForTable?.map((x) => {
        x.selected = props.FacEditList.filter((n) => n?.FactoryId === x?.FactoryId)[0]?.selected
      return x
    }));
    // setFactoryList(props.FacEditList);
  }, [props.FacEditList]);

  const handleClose = () => {
    const _FacList = FacListForTable.map((item, index2) => ({
      ...item,
      selected: false,
    }));

    props.DialogFacClose(false);
    // setFacListForTable(_FacList);
    // setFactoryList(_FacList);

    // if (props.FacEditList.length > 0) {
    //   props.DialogFacClose(false);
    // } else {
    //   props.DialogFacClose(false);
    //   setFacListForTable(_FacList);
    //   setFactoryList(_FacList);
    // }
  };

  const handleSearchFac = (FacName) => {
    const Factorys = FactoryList.filter(
      (x) => x.FactoryId === FacName.FactoryId
    );

    setFacListForTable(Factorys);
  };

  const handleCheckBox = (Fac, index, checked) => {
    const _FacList = FacListForTable.map((item, index2) =>
      index === index2
        ? {
          ...item,
          selected: checked ? true : false,
        }
        : item
    );

    const facCheck = FactoryList.map((x, index3) =>
      x.FactoryId === Fac.FactoryId
        ? {
          ...x,
          selected: checked,
        }
        : x
    );

    setFacListForTable(_FacList);
    setFactoryList(facCheck);
    // setFacListSelected([...facListSelected, _facCheck[0]]);
  };

  const handleSaveDialog = () => {
    props.FacSelectedList(FactoryList);
    props.DialogFacClose(false);

    // setFacListForTable(FactoryList);
  };
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={props.DialodAddFac}
        onClose={() => handleClose()}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id="responsive-dialog-title">
          {
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Add Factory
            </Typography>
          }
        </DialogTitle>
        <DialogContent>
          <Grid item sx={{ justifyContent: "center" }} xs={12} sm={6}>
            <div style={{ width: "100%" }}>
              <Autocomplete
                name="facId"
                id="factory"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
                options={FactoryList}
                // defaultValue={CustomerList?.find((v) =>
                //   formik.values.customer.cusId !== ""
                //     ? v.CustomerId === formik.values.customer.cusId
                //     : v.CustomerId === formik.values.customer.cusId
                // )}
                getOptionLabel={(option) => option.FactoryName}
                onChange={(e, newValue) => {
                  if (newValue) {
                    handleSearchFac(newValue);
                  } else {
                    setFacListForTable(FactoryList);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Factory"
                    placeholder="Search Factory Name"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <>
              <table style={{ width: "100%", maxWidth: "100%" }}>
                {FacListForTable?.map((Data, index) => (
                  <tbody>
                    <tr>
                      <td
                        key={index}
                        style={{
                          display: "flex",
                          border: "1px solid #e0e0e0",
                          flexWrap: "wrap",
                        }}
                      // onClick={() => setActionNo(Data.actionNo)}
                      >
                        <Checkbox
                          size="small"
                          sx={{
                            color: green[500],
                            "&.Mui-checked": {
                              color: green[500],
                            },
                          }}
                          id={"fac" + index}
                          name={"fac" + index}
                          onChange={(e) =>
                            handleCheckBox(Data, index, e.target.checked)
                          }
                          checked={Data?.selected || false}
                        />
                        <span
                          style={{
                            margin: "5px 0px 5px 5px",
                          }}
                        >
                          {Data.FactoryName}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            sx={{ width: 80 }}
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={() => handleClose()}
          >
            close
          </Button>
          <Button
            sx={{ width: 80 }}
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
              color: "white",
            }}
            onClick={() => handleSaveDialog()}
            disabled={
              props.FacEditList.length > 0
                ? false
                : FactoryList.find((x) => x.selected === true)
                  ? false
                  : true
            }
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
